export const SOCKET_APP = {
    ADMIN_EDIT_PERMISSIONS: 'admin_edit_permissions',
}